import { useState, useEffect, useCallback, useRef } from 'react';
import lib from '../../../assets/utils/lib';

const POLL_MS = 60_000;

/**
 * Poll open plan-request count for sidebar / tab badges
 * (pending + countered + org_accepted via status=open).
 * Refreshes on interval and when the tab regains focus.
 */
export function usePendingPlanRequestsCount(enabled = true) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const enabledRef = useRef(enabled);

  enabledRef.current = enabled;

  const refresh = useCallback(async () => {
    if (!enabledRef.current) {
      setCount(0);
      return 0;
    }
    setLoading(true);
    try {
      const total = await lib.getPendingPlanRequestsCount();
      setCount(total);
      return total;
    } catch (_) {
      return 0;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }

    refresh();
    const timer = setInterval(refresh, POLL_MS);

    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);

    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled, refresh]);

  return { count, loading, refresh };
}

export default usePendingPlanRequestsCount;
